import React from 'react';
import TrainingPage from '../components/training/TrainingPage';
import trainingContent from '../config/trainingContent';

export default function CopilotHRTraining() {
  return (
    <TrainingPage
      seo={{
        title: "Microsoft Copilot Training for HR Teams | Eagentix",
        description: "1-day onsite Microsoft Copilot training for HR teams. Hands-on with your own policies, job descriptions and case notes — screening, onboarding, policy Q&A and HR reporting."
      }}
      content={trainingContent.hr}
    />
  );
}
